import { Outlet, Navigate } from 'react-router-dom'
import { useAuthStore } from '@/store/auth'

/**
 * Wrapper for unauthenticated pages (login, forgot/reset password).
 * Redirects to / if the user is already authenticated.
 */
export function AuthLayout() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)

  if (isAuthenticated) {
    return <Navigate to="/" replace />
  }

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-surface-raised px-4 py-12">
      {/* Logo handled by each auth page */}

      {/* Page content */}
      <div className="w-full max-w-md">
        <Outlet />
      </div>
    </div>
  )
}
